import { FooterCopyrightDataElementType } from '@/components/sections/builder/elements/footer/footer-copyright/types';
import { ElementProps } from '@/components/sections/builder/types';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { usePathname } from 'next/navigation';
import React from 'react';
import { shallow } from 'zustand/shallow';

const ElementContent = ({ element, theme, preview }: ElementProps) => {
  const pathname = usePathname();
  const content = element.data as FooterCopyrightDataElementType;
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
    }),
    shallow
  );

  const themes = preview ? builder.theme : theme;

  return (
    <div className='footer_wrap bg-scheme w-full border-t-2'>
      <div
        className={cn(
          'theme_layout_page_width mx-auto px-10 duration-100',
          pathname.startsWith('/products/') &&
            themes?.productCard?.positionButtonAddToCart === 'fixed' &&
            'pb-[18.5em] lg:pb-[7.5em]',
          pathname.startsWith('/cart') &&
            themes?.cart?.fixedCheckoutButton &&
            'pb-[12.5em] md:pb-[8em]'
        )}
      >
        {content.text ? (
          <p className='theme_font text-xs' dangerouslySetInnerHTML={{ __html: content.text }} />
        ) : null}
      </div>
      <style jsx>
        {`
          .footer_wrap {
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
            text-align: ${content.textAlignment};
            background-color: ${content.colorSchemeFooterCopyright?.background || 'inherit'};
            color: ${content.colorSchemeFooterCopyright?.text || 'inherit'};
          }
          .bg-scheme {
            background-color: ${content.colorSchemeFooterCopyright?.background || 'inherit'};
            color: ${content.colorSchemeFooterCopyright?.text || 'inherit'};
          }
        `}
      </style>
    </div>
  );
};

export default ElementContent;
